import { RequestResponse } from "../types/RequestResponse";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractResponse = (response: RequestResponse): any | undefined => {
  if (response.success && response.data) {
    return response.data;
  }
  return;
};
